import { inject, provide, type InjectionKey, type Ref } from "vue";
import type { ScaleMap } from "../interfaces";

type CartesianChart = {
	scales: Ref<ScaleMap>;
};

const symbol: InjectionKey<CartesianChart> = Symbol();

export const provideCartesianChart = (chart: CartesianChart) => {
	provide(symbol, chart);
};

export const useCartesianChart = () => {
	const chart = inject(symbol);
	if (!chart) throw new Error("Must be a child of cartesian chart");

	return chart;
};
